/**
 * 後台／合作方可編輯的連結（banner、精選分類、物流追蹤、合作商品）只放行 http(s) 與站內相對路徑，
 * 擋掉 javascript: 之類會在點擊時執行的 scheme。不合法回空字串。
 */
export const safeUrl = (url?: string | null) => {
  const value = url?.trim() ?? ''
  return /^(https?:\/\/|\/(?!\/))/i.test(value) ? value : ''
}
